const DATE_ONLY_PREFIX = /^(\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]))/;

function formatDateToYmd(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function normalizeDateConfigValue(value: unknown): string | undefined {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }

  if (typeof value === "string") {
    const match = value.match(DATE_ONLY_PREFIX);
    if (match) {
      return match[1];
    }
  }

  const d = value instanceof Date ? value : new Date(value as string | number);
  if (isNaN(d.getTime())) {
    return undefined;
  }

  return formatDateToYmd(d);
}
